module.exports = __webpack_public_path__ + "img/project_20.6aa3d9b5.jpg";